import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-hemingway',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map